import React, { useState, useEffect, useRef } from "react";
import styles from "./ForgotPage.module.css";

import { forgotPasswordApi } from "../../config/forgotPasswordApi";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

export default function ResetPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const btn = useRef();

  const emailValidation = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/;

  const handleSubmit = (e) => {
    e.preventDefault();





    if (emailValidation.test(email) === false) {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="22" />
            &nbsp; Please Enter Valid Email Address!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        setLoading(true);
        btn.current.setAttribute("disabled", "disabled");
        const forgot = async () => {
          const forgot = await forgotPasswordApi(email);
  
          if (forgot.error) {
              toast.error(
                <span style={{ display: "flex", alignItems: "center" }}>
                  <BiError size="30" style={{marginRight: "10px"}} />
                  {forgot.error.response.data.message}
                </span>,
                {
                  position: "bottom-left",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                }
              );
  
              setLoading(false);
              btn.current.removeAttribute("disabled");
            }
          else if (forgot.data) {
            toast.success(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BsCheckAll size="30" style={{marginRight: "10px"}} />
                 Kindly Check Your Email
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
            setEmail("");
  
            setLoading(false);
            btn.current.removeAttribute("disabled");
          }
        };
        forgot();
      }
  };

  return (
    <div className={styles.mainall}>
      <div className={styles.main}>
        <div className={styles.formCont}>
          <h1 className={styles.heading}>Forgot Password</h1>
          <p className={styles.des}>
            Kindly enter your email below and we will reset your password.
          </p>
          <form onSubmit={(e) => handleSubmit(e)}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              className={styles.input}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className={styles.login} ref={btn}>
              {loading ? (
                <div class="spinner-border" role="status"></div>
              ) : (
                "Request password"
              )}
            </button>
          </form>
          <div className={styles.allgo}>
            <p className={styles.next}>
              Remember your details?{" "}
              <Link to="/login" className={styles.go}>
                Sign in here
              </Link>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}
